import styled from "styled-components";

export const GlobalContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f0f2f5;

  .header-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const UploadContainer = styled.div`
  padding: 24px;
  margin-inline: 120px;

  @media (max-width: 1024px) {
    margin-inline: 16px;
    padding: 16px;
  }
`;

export const DocumentCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #f0f0f0;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  }

  &.required {
    border-left: 4px solid #f5222d;
  }

  &.uploaded {
    border-left: 4px solid #52c41a;
  }
`;

export const DocumentState = styled.span`
  text-transform: capitalize;
  font-size: 14px;
  font-family: Roboto;
  padding: 3px 10px;
  border-radius: 4px;
  font-weight: bold;
  min-width: 85px;
  display: inline-block;
  text-align: center;
  background-color: ${({ bg }) => bg};
  color: ${({ color }) => color};
`;
